import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module clipboard/utils/viewtoplaintext
 */
// Elements which should not have empty-line padding.
// Most `view.ContainerElement` want to be separate by new-line, but some are creating one structure
// together (like `<li>`) so it is better to separate them by only one "\n".
var smallPaddingElements = ['figcaption', 'li'];
/**
 * Converts {@link module:engine/view/item~Item view item} and all of its children to plain text.
 *
 * @param {module:engine/view/item~Item} viewItem View item to convert.
 * @returns {String} Plain text representation of `viewItem`.
 */

export default function viewToPlainText(viewItem) {
  var text = '';

  if (viewItem.is('text') || viewItem.is('textProxy')) {
    // If item is `Text` or `TextProxy` simple take its text data.
    text = viewItem.data;
  } else if (viewItem.is('img') && viewItem.hasAttribute('alt')) {
    // Special case for images - use alt attribute if it is provided.
    text = viewItem.getAttribute('alt');
  } else {
    // Other elements are document fragments, attribute elements or container elements.
    // They don't have their own text value, so convert their children.
    var prev = null;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = viewItem.getChildren()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;
        var childText = viewToPlainText(child); // Separate container element children with one or more new-line characters.

        if (prev && (prev.is('containerElement') || child.is('containerElement'))) {
          if (smallPaddingElements.includes(prev.name) || smallPaddingElements.includes(child.name)) {
            text += '\n';
          } else {
            text += '\n\n';
          }
        }

        text += childText;
        prev = child;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return text;
}